import React, { useEffect, useState } from 'react';
import ReusableTable from '../../components/ReusableTable';
import CreateButton from '../../components/CreateButton';
import EditButton from '../../components/EditButton';
import DeleteButton from '../../components/DeleteButton';
import ViewButton from '../../components/ViewButton';
import {
  getCategorias,
  createCategoriaGeneral,
  editCategoriaGeneral,
  deleteCategoriaGeneral
} from '../../services/Admin/categoriaService';
import {
  getSubcategoriasByCategoria,
  createSubcategoria,
  editSubcategoria,
  deleteSubcategoria
} from '../../services/Admin/subcategoriaService';

const columns = [
  { key: 'id_categoria', label: 'ID' },
  { key: 'area_id', label: 'Area ID' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'descripcion', label: 'Descripción' },
  { key: 'estado', label: 'Estado' }
];




// Formulario para CREAR (requiere area_id porque no hay fila seleccionada)
const formConfig = [
  { name: 'area_id', label: 'Area ID', type: 'number' },
  { name: 'nombre', label: 'Nombre', type: 'text' },
  { name: 'descripcion', label: 'Descripción', type: 'text' },
  { name: 'estado', label: 'Estado', type: 'number' }
];

// Formulario para EDITAR (no permite editar area_id, se toma del row)
const editFormConfig = [
  { name: 'nombre', label: 'Nombre', type: 'text' },
  { name: 'descripcion', label: 'Descripción', type: 'text' },
  { name: 'estado', label: 'Estado', type: 'number' }
];

// Configuración para Subcategoría
const subcategoriaColumns = [
  { key: 'id_subcategoria', label: 'ID' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'descripcion', label: 'Descripción' },
  { key: 'estado', label: 'Estado' }
];

const subcategoriaFormConfig = [
  { name: 'nombre', label: 'Nombre', type: 'text' },
  { name: 'descripcion', label: 'Descripción', type: 'text' },
  { name: 'estado', label: 'Estado', type: 'number' }
];

const CategoriaPage = () => {
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    getCategorias()
      .then(setData)
      .catch(() => setData([]));
  }, [reload]);

  const handleCreate = async (values, onDone) => {
    const success = await createCategoriaGeneral(values);
    if (success) setReload(r => !r);
    onDone(success);
  };

  const handleEdit = async (id, values, onDone) => {
    const success = await editCategoriaGeneral(id, values);
    if (success) setReload(r => !r);
    onDone(success);
  };

  const handleDelete = async (id, onDone) => {
    const success = await deleteCategoriaGeneral(id);
    if (success) setReload(r => !r);
    onDone(success);
  };

  const actionRender = row => (
    <>
      <EditButton
        item={row}
        formConfig={editFormConfig}
        onEdit={(values, onDone) => handleEdit(row.id_categoria, { ...values, area_id: row.area_id }, onDone)}
      />
      <ViewButton
        onView={() => getSubcategoriasByCategoria(row.id_categoria)}
        columns={subcategoriaColumns}
        formConfig={subcategoriaFormConfig}
        onCreate={createSubcategoria(row.id_categoria)}
        onEdit={editSubcategoria()}
        onDelete={deleteSubcategoria()}
      />
      <DeleteButton
        item={row}
        onDelete={onDone => handleDelete(row.id_categoria, onDone)}
      />
    </>
  );

  return (
    <div>
      <div style={{ overflow: 'hidden' }}>
        <CreateButton formConfig={formConfig} onCreate={handleCreate} />
      </div>
      <ReusableTable
        data={data}
        columns={columns}
        actionRender={actionRender}
      />
    </div>
  );
};

export default CategoriaPage;
